import { Component, OnInit, ViewEncapsulation ,Inject} from '@angular/core';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import { BusinessInfo } from 'src/app/Models/BusinessInfoResponse';
import { DatePipe } from '@angular/common';
import { AppComponent } from 'src/app/app.component'; 
import { UserDashboardComponent } from '../user-dashboard.component';
export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}
@Component({
  selector: 'app-manage-business',
  templateUrl: './manage-business.component.html',
  styleUrls: ['./manage-business.component.css']
})
export class ManageBusinessComponent implements OnInit {

  constructor(public service:SharkifyAiSerivceService,public router: Router,public datepipe : DatePipe,public app: AppComponent,public dialog: MatDialog,public user : UserDashboardComponent) { }
  displayedColumns: string[] = ['BusinessInfo_BusinessName', 'BusinessInfo_BusinessType', 'Created_On', 'actions'];
  dataSource : any;
  BusinessInfos: BusinessInfo[] = [];
  UserId: string = "";
  ProfileName: string = "";
  UserNameAsPhoto: string = "";
  CheckBusinessInfoId: string = "";
  getSafeValue(value: string | null): string {
    return (value === null || value === "undefined") ? "" : value;
  }
  ngOnInit(): void {
    this.UserId = this.getSafeValue(localStorage.getItem("UserId"));
    this.CheckBusinessInfoId= this.getSafeValue(localStorage.getItem("CheckBusinessInfoId"));
    this.app.displayLoader(true);
    this.service.GetBusinessInfoDetails(this.UserId).subscribe(data => {
        this.BusinessInfos = data;
        this.BusinessInfos.forEach(item => {
          if(item.CreatedOn == undefined || item.CreatedOn == null){
            item.Created_On = "";
          }else{
            item.Created_On = this.datepipe.transform(item.CreatedOn,"dd - MMM - yyyy") + "";
          }
        })
        // this.ProfileName = this.BusinessInfos.BusinessInfo_BusinessName;
        this.UserNameAsPhoto = `${Array.from(this.ProfileName)[0]}`;
        this.dataSource = new MatTableDataSource(this.BusinessInfos);
        this.app.displayLoader(false);
    }, error => {
      this.app.displayLoader(false);
    });
  }
  ViewDetails(InfoId : any){
    localStorage.setItem("InfoId",""+ InfoId);
    this.service.setBusinessInfo(InfoId)
    this.router.navigate(
      ["/Dashboard/BusinessInfo"]
    );
  }
  Switch(InfoId : any, name : string , index : number){
    this.user.onSwitch(index , name , InfoId);
    this.ngOnInit();
  }

  Settings(InfoId : any){

  }
  openBrandModal() {
    this.router.navigate(["/Dashboard/Questionary"]);
  }

  DeleteButton(name : any , id : any){
    let dialog_data ={
      Businessname : name,
      Businessinfiid : id,
      userid : this.UserId,
    }
    const dialogRef = this.dialog.open(DeleteDialog,{
        height:'auto',
        width:'340px',
        data:dialog_data,
    });
    dialogRef.afterClosed().subscribe(result => { 
    });
  }
}
@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.html',
  styleUrls: ['./delete-dialog.css'],
  encapsulation: ViewEncapsulation.None
})
export class DeleteDialog {
  constructor( public dialogRef: MatDialogRef<DeleteDialog>,private toastr: ToastrService,public service:SharkifyAiSerivceService,@Inject(MAT_DIALOG_DATA) public data : any){}
  deleteBusiness(){
    this.service.DeleteBusinessInfo(this.data.userid,this.data.Businessinfiid).subscribe(DATA => {
      if(DATA.Code == 200){
        this.toastr.success(this.data.Businessname + " got deleted")
        this.dialogclose();
      }
    });
  }
  dialogclose(){
    this.dialogRef.close()
  }
}